// removed by extract-text-webpack-plugin
module.exports = {"wishContainer":"_5M9mttnZI5txK0yLULEbT","userImage":"_3xX-Hep0uXw8GHY7hzQdlb","textContainer":"_3JDJ6s3bY3Avgme3_jqaVR","wishText":"_1fnnNPdwEPoismuqOw-BPh","upwishContainer":"_2gxs5vUL3jTFdx1ZqCAK9L","upwishButton":"seDULjEzwbpjvLKwXM8kK","upwished":"_3EU8FbCKamlwdA2gWFeo1T","donateButton":"_3IKbrES6wTg6sVRhlLrfkF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WishCard/css/WishCard.css
// module id = 323
// module chunks = 0